import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { NEW_DEALER_PAGE_ID } from './CtNewDealer/ctNewDealerConfig';
import { REFERRAL_PAGE_ID } from './CtReferral/ctReferralConfig';

// Container Trader: pages built in code, so there is no Console asset to fetch
const CODE_PAGE_IDS = [NEW_DEALER_PAGE_ID, REFERRAL_PAGE_ID];

export const loadData = (params, search) => dispatch => {
  const pageId = params.pageId;
  if (CODE_PAGE_IDS.includes(pageId)) {
    return Promise.resolve();
  }
  const pageAsset = { [pageId]: `content/pages/${pageId}.json` };
  const hasFallbackContent = false;
  return dispatch(fetchPageAssets(pageAsset, hasFallbackContent));
};
